export const NOTIFICATIONS = {
    SUCCESSFUL_LOGIN: 'You have successfully logged-in.',
    SOMETHING_WENT_WRONG: 'Something went wrong, please try again.',
    SUCCEFUL_LOGOUT: 'You are successfully logged-out.',
    INVALID_USER_PASSWORD: 'Invalid username or password.',
    COMPANY_UPDATED: 'Company details updated successfully',
    ACCOUNT_UPDATED: 'Account details updated successfully',
    VERIFICATION_DOCUMENTS_UPDATED:
        'Verification Documents updated successfully',
    DOCUMENTS_UPLOADED: 'Verification documents uploaded successfully',
    PASSWORD: 'Password changed successfully',
    INVITATION_SUCCESS: 'Invitation sent successfully',
    INVALID_EMAIL_OR_PASSWORD: 'Enter valid Email and Password',
    PROFILE_PICTURE_UPDATED: 'Profile Picture Updated',
    PROFILE_DETAILS_UPDATED: 'Profile Details Updated',
    COMPANY_REJECTED: 'Company Has Been Rejected',
    COMPANY_ACCEPTED: 'Company Has  Been Accepted',
    QUOTE_ACCEPTED: 'Quote has been Accepted',
    QUOTE_REJECTED: 'Quote has been Rejected',
    INVALID_EXPIRY_DATE: 'Invalid Date, please select a Valid Date',
    IMAGE_SIZE: 'The Size limit for Image is 2.0MB',
    REQ_SENT: 'Request sent',
}

export const ERRORS = {
    NETWORK_ERROR: 'Network Error',
}
